/** North America Ring-Back Tone */
export class RBT {
  private static readonly DURATION_TONE_IN_MS = 2000;
  private static readonly DURATION_PAUSE_IN_MS = 4000;
  private static readonly TONE_FREQ_1 = 440;
  private static readonly TONE_FREQ_2 = 480;

  private static timer: number | undefined;
  private static context: AudioContext | null;
  private static noop = () => {};

  public static start() {
    this.context = new AudioContext();
    const osc1 = this.context.createOscillator();
    const osc2 = this.context.createOscillator();
    osc1.frequency.value = this.TONE_FREQ_1;
    osc2.frequency.value = this.TONE_FREQ_2;

    const node = this.context.createGain();
    node.gain.value = 0.25;

    const filter = this.context.createBiquadFilter();
    filter.type = 'lowpass';
    filter.frequency.value = 8000;

    osc1.connect(node);
    osc2.connect(node);

    node.connect(filter);
    filter.connect(this.context.destination);
    osc1.start(0);
    osc2.start(0);
    this.context.suspend();

    const pause = () => {
      this.context && this.context.suspend().catch(this.noop);
    };

    const play = () => {
      if (!this.context) {
        return;
      }

      this.context.resume().then(() => {
        setTimeout(pause, this.DURATION_TONE_IN_MS);
      }).catch(this.noop);
    };

    play();

    const interval = this.DURATION_PAUSE_IN_MS + this.DURATION_TONE_IN_MS;
    this.timer = window.setInterval(play, interval);
  }

  public static stop() {
    clearInterval(this.timer);
    if (this.context) {
      this.context.close();
      this.context = null;
    }
  }
}
